// extracted by mini-css-extract-plugin
export var avatarContainer = "_he-0";
export var avatarTypingWave = "_he-i";
export var gray = "_he-f";
export var green = "_he-c";
export var icon = "_he-9";
export var image = "_he-1";
export var lg = "_he-6";
export var md = "_he-5";
export var presenceDot = "_he-b";
export var red = "_he-d";
export var sm = "_he-4";
export var status = "_he-a";
export var typingDot = "_he-h";
export var typingPill = "_he-g";
export var xl = "_he-7";
export var xs = "_he-3";
export var xxl = "_he-8";
export var xxs = "_he-2";
export var yellow = "_he-e";